// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UniversalPOS — Enterprise Light Theme */

:root {
  --primary: #2563EB;
  --primary-hover: #1D4ED8;
  --primary-light: #3B82F6;
  --primary-subtle: #E8F2FF;

  --bg-primary: #F5F7FB;
  --bg-secondary: #FFFFFF;
  --bg-tertiary: #F9FAFB;
  --bg-card: #FFFFFF;
  --bg-hover: #F3F8FF;
  --bg-selected: #E8F2FF;

  --text-heading: #111827;
  --text-primary: #111827;
  --text-body: #374151;
  --text-secondary: #374151;
  --text-muted: #6B7280;

  --success: #22C55E;
  --success-subtle: #DCFCE7;
  --warning: #F59E0B;
  --warning-subtle: #FEF3C7;
  --error: #EF4444;
  --error-subtle: #FEE2E2;
  --info: #0EA5E9;
  --info-subtle: #E0F2FE;

  --border-color: #E5E7EB;
  --border-light: #F3F4F6;

  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.04);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.06), 0 4px 6px -4px rgba(0, 0, 0, 0.04);

  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;

  --sidebar-width: 260px;
  --header-height: 64px;

  --transition-fast: 150ms ease;
  --transition-normal: 200ms ease;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  max-width: 100%;
  overflow: hidden;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  background: var(--bg-primary);
  color: var(--text-body);
  font-size: 14px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  height: 100%;
  max-width: 100%;
  overflow: hidden;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #9CA3AF;
}

::selection {
  background: var(--primary-subtle);
  color: var(--primary);
}

a {
  color: var(--primary);
  text-decoration: none;
  transition: color var(--transition-fast);
}

a:hover {
  color: var(--primary-hover);
}

/* Typography utilities */
.text-heading { color: var(--text-heading); }
.text-body { color: var(--text-body); }
.text-muted { color: var(--text-muted); }
.text-primary { color: var(--primary); }
.text-success { color: var(--success); }
.text-danger { color: var(--error); }
.text-warning { color: var(--warning); }

/* Page layout */
.page-container {
  max-width: 100%;
}

.page-header {
  margin-bottom: 24px;
}

.page-header h1,
.page-header .ant-typography h3 {
  margin: 0 0 4px;
  color: var(--text-heading);
  font-weight: 600;
}

.page-header .page-subtitle {
  color: var(--text-muted);
  font-size: 14px;
}

.page-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.page-card .ant-card-head {
  border-bottom: 1px solid var(--border-light);
  min-height: 52px;
}

.page-card .ant-card-head-title {
  color: var(--text-heading);
  font-weight: 600;
}

/* Animations */
.fade-in {
  animation: fadeIn var(--transition-normal) ease-in;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
}

/* KPI / Stat cards */
.stat-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px 24px;
  box-shadow: var(--shadow-sm);
  transition: box-shadow var(--transition-fast), border-color var(--transition-fast);
  height: 100%;
}

.stat-card:hover {
  box-shadow: var(--shadow-md);
  border-color: #D1D5DB;
}

.stat-card .stat-label {
  font-size: 13px;
  color: var(--text-muted);
  font-weight: 500;
  margin-bottom: 4px;
}

.stat-card .stat-value {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-heading);
  line-height: 1.2;
}

.stat-card .stat-trend {
  display: flex;
  align-items: center;
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
}

.stat-icon {
  width: 44px;
  height: 44px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon--success { background: var(--success-subtle); color: var(--success); }
.stat-icon--primary { background: var(--primary-subtle); color: var(--primary); }
.stat-icon--warning { background: var(--warning-subtle); color: var(--warning); }
.stat-icon--info { background: var(--info-subtle); color: var(--info); }

/* Custom card */
.custom-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px;
  box-shadow: var(--shadow-sm);
  transition: box-shadow var(--transition-fast);
}

.custom-card:hover {
  box-shadow: var(--shadow-md);
}

/* App shell */
.app-sider {
  background: var(--bg-secondary) !important;
  border-right: 1px solid var(--border-color) !important;
  box-shadow: none !important;
}

.app-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-sider .ant-menu {
  flex: 1;
  overflow-y: auto;
  border-inline-end: none !important;
  padding: 8px;
}

.app-sider .sider-logo {
  height: var(--header-height);
  display: flex;
  align-items: center;
  padding: 0 20px;
  border-bottom: 1px solid var(--border-light);
  gap: 12px;
}

.app-sider .sider-logo-icon {
  width: 36px;
  height: 36px;
  background: var(--primary);
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
  font-weight: 700;
  flex-shrink: 0;
}

.app-sider .sider-logo-text {
  overflow: hidden;
}

.app-sider .sider-logo-text .brand-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-heading);
  display: block;
  line-height: 1.3;
  white-space: nowrap;
}

.app-sider .sider-logo-text .brand-sub {
  font-size: 11px;
  color: var(--text-muted);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-sider .ant-menu-item {
  margin: 2px 0;
  border-radius: var(--radius-md) !important;
  font-weight: 500;
}

.app-sider .ant-menu-item .ant-menu-item-icon {
  font-size: 18px;
}

.app-sider-footer {
  margin-top: auto;
  padding: 16px 20px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-tertiary);
}

.app-sider-footer .user-name {
  color: var(--text-heading);
  font-size: 13px;
  font-weight: 600;
}

.app-sider-footer .user-role {
  color: var(--text-muted);
  font-size: 11px;
  text-transform: capitalize;
}

.app-header {
  background: var(--bg-secondary) !important;
  border-bottom: 1px solid var(--border-color) !important;
  padding: 0 24px !important;
  height: var(--header-height) !important;
  line-height: var(--header-height) !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: none !important;
}

.app-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.app-header-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-heading);
}

.app-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-header-search {
  width: 280px;
}

.app-header-search .ant-input-affix-wrapper {
  border-radius: var(--radius-md);
  background: var(--bg-tertiary);
  border-color: var(--border-color);
}

.app-header-icon-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  color: var(--text-muted);
  cursor: pointer;
  transition: background var(--transition-fast), color var(--transition-fast);
}

.app-header-icon-btn:hover {
  background: var(--bg-hover);
  color: var(--primary);
}

.app-content {
  padding: 24px;
  background: var(--bg-primary);
  min-height: calc(100vh - var(--header-height));
  overflow: auto;
}

.app-user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 8px 4px 4px;
  border-radius: var(--radius-md);
  transition: background var(--transition-fast);
}

.app-user-trigger:hover {
  background: var(--bg-hover);
}

.app-user-trigger .user-display-name {
  color: var(--text-body);
  font-size: 13px;
  font-weight: 500;
}

/* Sales workspace (product grid + cart) */
.pos-layout {
  display: flex;
  height: calc(100vh - var(--header-height) - 48px);
  gap: 20px;
  overflow: hidden;
}

.pos-products-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.pos-search-bar {
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
}

.pos-products-grid-wrap {
  flex: 1;
  overflow: auto;
  background: var(--bg-card);
  border-radius: var(--radius-lg);
  padding: 16px;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.pos-cart-panel {
  width: 420px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
}

.product-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 16px;
  cursor: pointer;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), transform var(--transition-fast);
  text-align: center;
}

.product-card:hover {
  border-color: var(--primary);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}

.product-card .product-name {
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--text-heading);
  font-size: 13px;
}

.product-card .product-price {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary);
}

.cart-container {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-sm);
}

.cart-header {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light);
}

.cart-items {
  flex: 1;
  overflow-y: auto;
  padding: 8px 12px;
}

.cart-table .ant-table {
  width: 100%;
}

.cart-table .ant-table-tbody > tr > td {
  padding: 10px 6px;
  vertical-align: middle;
}

.cart-table .ant-table-tbody > tr > td:first-child {
  padding-left: 4px;
  padding-right: 10px;
}

.cart-item-name {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 2px 0;
}

.cart-item-name-text {
  display: block;
  font-size: 13px;
  line-height: 1.35;
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
}

.cart-item-barcode {
  display: block;
  font-size: 11px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-item-price,
.cart-item-total {
  font-size: 13px;
  white-space: nowrap;
}

.cart-item-qty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.cart-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--border-light);
  background: var(--bg-tertiary);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

.cart-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cart-total-amount {
  font-size: 22px;
  font-weight: 700;
  color: var(--success);
}

.pos-checkout-btn {
  height: 52px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}

/* Login */
.login-container {
  height: 100%;
  min-height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background: var(--bg-primary);
  padding: 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.login-box {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-xl);
  padding: 28px 32px 24px;
  width: 100%;
  max-width: 420px;
  box-shadow: var(--shadow-lg);
  margin: auto;
}

.login-create-account-btn {
  border-color: var(--primary) !important;
  color: var(--primary) !important;
}

.login-create-account-btn:hover {
  border-color: var(--primary) !important;
  color: var(--primary) !important;
  background: color-mix(in srgb, var(--primary) 8%, transparent) !important;
}

.login-create-account-row {
  text-align: center;
  margin-top: 8px;
}

.login-box--register {
  max-width: 480px;
  max-height: 92vh;
  overflow-y: auto;
  padding: 24px 32px;
}

.login-logo {
  text-align: center;
  margin-bottom: 20px;
}

.login-logo-icon {
  width: 56px;
  height: 56px;
  background: var(--primary);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: white;
}

.login-logo h2 {
  margin: 0;
  color: var(--text-heading);
  font-weight: 700;
}

.login-logo .login-subtitle {
  color: var(--text-muted);
  margin-top: 4px;
}

.login-footer {
  text-align: center;
  margin-top: 24px;
  color: var(--text-muted);
  font-size: 12px;
}

/* Empty states */
.empty-state {
  padding: 48px 24px;
  text-align: center;
}

.empty-state-icon {
  color: var(--text-muted);
  margin-bottom: 12px;
}

/* Table wrapper */
.table-card {
  border-radius: var(--radius-lg);
  overflow: auto;
  max-width: 100%;
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
  -webkit-overflow-scrolling: touch;
}

.table-card .ant-table-wrapper {
  border-radius: var(--radius-lg);
  min-width: 0;
}

/* Toolbar */
.page-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 12px;
  flex-wrap: wrap;
}

/* App loader */
.app-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background: var(--bg-primary);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.app-loader .spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--border-color);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.app-loader .text {
  margin-top: 16px;
  color: var(--text-muted);
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Ant Design overrides */
.ant-table {
  background: var(--bg-card) !important;
}

.ant-table-thead > tr > th {
  background: var(--bg-tertiary) !important;
  color: var(--text-body) !important;
  font-weight: 600 !important;
  border-bottom: 1px solid var(--border-color) !important;
  font-size: 13px !important;
  position: sticky;
  top: 0;
  z-index: 2;
}

.ant-table-thead > tr > th::before {
  display: none !important;
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid var(--border-light) !important;
  color: var(--text-body);
}

.ant-table-tbody > tr:hover > td {
  background: var(--bg-hover) !important;
}

.ant-table-wrapper .ant-table-pagination {
  margin: 16px !important;
}

.ant-card {
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-sm);
}

.ant-modal-content {
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-lg) !important;
}

.ant-form-item-label > label {
  color: var(--text-body) !important;
  font-weight: 500;
}

.ant-input:focus,
.ant-input-affix-wrapper-focused,
.ant-select-focused .ant-select-selector,
.ant-picker-focused {
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12) !important;
}

.ant-btn-primary {
  box-shadow: none !important;
}

.ant-btn-primary:hover {
  background: var(--primary-hover) !important;
}

.ant-tabs-tab {
  font-weight: 500;
}

.ant-badge-count {
  box-shadow: none;
}

.ant-spin-dot-item {
  background-color: var(--primary) !important;
}

.ant-message {
  z-index: 10000 !important;
}

/* Dashboard */
.dashboard-page .dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.dashboard-quick-actions {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
}

.dashboard-quick-action {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  cursor: pointer;
  text-align: left;
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);
  box-shadow: var(--shadow-sm);
}

.dashboard-quick-action:hover {
  border-color: var(--primary);
  background: var(--bg-hover);
  box-shadow: var(--shadow-md);
}

.dashboard-quick-action__icon {
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: var(--primary-subtle);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dashboard-quick-action__text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.dashboard-quick-action__label {
  font-weight: 600;
  font-size: 13px;
  color: var(--text-heading);
}

.dashboard-quick-action__desc {
  font-size: 11px;
  color: var(--text-muted);
}

.dashboard-inventory-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.dashboard-inventory-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.dashboard-inventory-value {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-heading);
  line-height: 1.2;
}

.dashboard-counts {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 16px 20px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  color: var(--text-muted);
  font-size: 13px;
}

.dashboard-counts strong {
  color: var(--text-heading);
  font-weight: 600;
}

@media (max-width: 768px) {
  .dashboard-quick-actions {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .app-header-search {
    display: none;
  }

  .pos-layout {
    flex-direction: column;
    height: auto;
  }

  .pos-cart-panel {
    width: 100%;
  }

  .app-content {
    padding: 16px;
  }
}

/* === Phase 1: SaaS shell layout === */
.app-shell {
  min-height: 100%;
  height: 100%;
  max-width: 100%;
  flex-direction: column;
  display: flex;
  overflow: hidden;
}

.app-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px !important;
  padding: 0 20px !important;
  background: linear-gradient(90deg, #1D4ED8 0%, #2563EB 100%) !important;
  border-bottom: none;
  line-height: 1;
  flex-shrink: 0;
  z-index: 100;
}

.app-topbar-left,
.app-topbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.app-brand-mark {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.app-topbar-icon,
.app-topbar-link {
  color: #fff !important;
}

.app-topbar-user {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.app-body {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  overflow: hidden;
}

.app-sider-v2 {
  background: var(--bg-card) !important;
  border-right: 1px solid var(--border-color);
  transition: width 0.2s ease, min-width 0.2s ease, max-width 0.2s ease !important;
  overflow: hidden;
  flex-shrink: 0;
}

.app-sider-v2 .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.app-sider-brand {
  padding: 16px 16px 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.app-sider-brand-name {
  font-weight: 700;
  font-size: 14px;
  color: var(--text-heading);
}

.app-sider-brand-co {
  font-size: 11px;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.app-sider-menu {
  border-inline-end: none !important;
}

.app-content-v2 {
  flex: 1;
  min-height: 0;
  min-width: 0;
  padding: 20px 24px;
  overflow-x: auto;
  overflow-y: auto;
  background: var(--bg-primary);
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.app-content-v2--workspace {
  padding: 12px 16px;
  overflow: hidden;
}

.table-card--scroll {
  overflow: auto;
}

.table-card--scroll .ant-table-wrapper {
  min-width: 100%;
}

.settings-form-card {
  max-width: 100%;
}

.settings-page {
  width: 100%;
  max-width: 100%;
}

.settings-section-title {
  margin: 0 0 12px !important;
}

.settings-form--notifications {
  width: 100%;
}

.settings-form__actions--inline {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.settings-tabs .ant-tabs-content {
  width: 100%;
}

.settings-tabs .ant-tabs-tabpane {
  width: 100%;
}

.settings-page__header {
  margin-bottom: 16px;
}

.settings-tabs .ant-tabs-nav {
  margin-bottom: 16px;
}

.settings-tabs .ant-tabs-tab {
  padding: 8px 4px;
}

.settings-panel {
  width: 100%;
  max-width: 100%;
  border-radius: var(--radius-lg);
}

.settings-panel__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-light);
}

.settings-panel__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  background: rgba(37, 99, 235, 0.1);
  color: var(--primary);
  margin-right: 10px;
  vertical-align: middle;
}

.settings-panel__title {
  margin: 0 0 4px !important;
  display: inline;
  vertical-align: middle;
}

.settings-panel__desc {
  display: block;
  font-size: 13px;
  margin-top: 4px;
}

.settings-form .ant-form-item {
  margin-bottom: 16px;
}

.settings-form__actions {
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--border-light);
}

.settings-status-box {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 16px 20px;
  height: 100%;
}

.settings-status-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  gap: 12px;
}

.settings-table .ant-table {
  background: transparent;
}

@media (max-width: 768px) {
  .settings-panel__header {
    flex-direction: column;
  }
}

.form-page-shell .form-page-subtitle {
  display: block;
  margin: -12px 0 16px;
}

.enterprise-form-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
}

.enterprise-form-page--narrow .enterprise-form-card {
  max-width: 800px;
}

.enterprise-form-subtitle {
  display: block;
  font-size: 13px;
  margin-top: 2px;
}

.enterprise-form-card {
  flex: 1;
  width: 100%;
  max-width: 100%;
  padding: 20px 24px;
}

.enterprise-form-card .ant-form-item {
  margin-bottom: 16px;
}

.enterprise-section-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--primary);
  margin: 8px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.enterprise-line-items-header {
  display: grid;
  grid-template-columns: 80px 1fr 100px 120px 90px 48px;
  gap: 8px;
  padding: 6px 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-light);
  margin-bottom: 8px;
}

.enterprise-line-item-row {
  display: grid;
  grid-template-columns: 80px 1fr 100px 120px 90px 48px;
  gap: 8px;
  margin-bottom: 8px;
  align-items: center;
}

.enterprise-line-items-header--adjust {
  grid-template-columns: 1fr 120px 120px 48px;
}

.enterprise-line-item-row--adjust {
  grid-template-columns: 1fr 120px 120px 48px;
}

.enterprise-line-items-header--transfer {
  grid-template-columns: 1fr 120px 48px;
}

.enterprise-line-item-row--transfer {
  grid-template-columns: 1fr 120px 48px;
}

.enterprise-totals-box {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 12px 16px;
  margin-top: 16px;
  margin-left: auto;
  max-width: 320px;
}

.enterprise-totals-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  font-size: 13px;
}

.enterprise-totals-row--total {
  border-top: 1px solid var(--border-color);
  margin-top: 6px;
  padding-top: 8px;
  font-weight: 700;
  font-size: 15px;
}

.customers-workspace {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  gap: 12px;
}

.customers-workspace__stats {
  flex-shrink: 0;
}

.customers-workspace__body {
  display: flex;
  gap: 16px;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.customers-workspace__list {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.customers-workspace__panel {
  width: 420px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
}

.customers-workspace__panel--open {
  width: 480px;
}

.customers-workspace__panel-header {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border-light);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.customers-workspace__panel-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.customers-workspace__panel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px;
  text-align: center;
  color: var(--text-muted);
}

.customers-workspace__toolbar {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
}

.customers-workspace__table {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.customers-workspace__table .ant-table-row {
  cursor: pointer;
}

.customers-workspace__table .ant-table-row--selected {
  background: rgba(37, 99, 235, 0.08) !important;
}

@media (max-width: 1200px) {
  .customers-workspace__body {
    flex-direction: column;
    overflow: auto;
  }

  .customers-workspace__panel,
  .customers-workspace__panel--open {
    width: 100%;
    max-height: 480px;
  }
}

@media (max-width: 768px) {
  .enterprise-line-items-header,
  .enterprise-line-item-row {
    grid-template-columns: 1fr;
  }
}

.form-page-actions {
  flex-wrap: wrap;
}

.page-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.page-toolbar .ant-space {
  flex-wrap: wrap;
}

/* Journal Day Book */
.journals-page .journal-criteria-card {
  margin-bottom: 16px;
}

.journals-page .journal-criteria-card .ant-card-head {
  min-height: 40px;
  background: #f8fafc;
}

.journal-daybook-card .ant-card-body {
  padding-top: 16px;
}

.journal-daybook-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.journal-empty-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px 24px;
  text-align: center;
}

.journal-daybook-table .journal-amount-col {
  font-variant-numeric: tabular-nums;
}

.journal-daybook-table .journal-totals-row td {
  background: #f0fdf4 !important;
  border-top: 2px solid #16a34a;
}

.journal-daybook-table .ant-table-thead > tr > th {
  background: #f1f5f9 !important;
  font-weight: 600;
  font-size: 12px;
  white-space: nowrap;
}

@media (max-width: 992px) {
  .app-content-v2 {
    padding: 16px;
  }

  .page-header,
  .page-header-row {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }

  .form-page-actions,
  .page-header-row > *:last-child {
    width: 100%;
  }

  .app-content-v2--invoice-fit,
  .app-content-v2--enterprise-fit,
  .app-content-v2--enterprise-fit > *,
  .invoice-form-page--fit,
  .invoice-form-card--fit,
  .invoice-form-card--fit.ant-form,
  .receipt-form-page--fit,
  .enterprise-form-page,
  .purchase-form-page--fit {
    height: auto !important;
    max-height: none !important;
    overflow: visible !important;
    display: block !important;
  }

  .app-content-v2--invoice-fit,
  .app-content-v2--enterprise-fit {
    overflow-x: auto !important;
    overflow-y: auto !important;
    display: block !important;
  }

  .invoice-form-bottom,
  .invoice-form-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .invoice-summary-box,
  .invoice-summary-box--compact {
    width: 100% !important;
    max-width: 100%;
    margin-top: 12px;
  }

  .invoice-form-topbar__actions,
  .invoice-form-toolbar,
  .invoice-form-toolbar__primary,
  .invoice-form-btn-group {
    flex-wrap: wrap;
    width: 100%;
  }

  .invoice-compact-row > .ant-col {
    flex: 1 1 calc(50% - 8px) !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .ant-modal {
    max-width: calc(100vw - 24px) !important;
    margin: 12px auto !important;
  }

  .ant-modal .ant-modal-content {
    max-height: calc(100vh - 48px);
    overflow: auto;
  }
}

@media (max-width: 768px) {
  .app-topbar-link {
    display: none !important;
  }

  .app-content-v2 {
    padding: 12px;
  }

  .ant-table {
    font-size: 12px;
  }

  .page-container {
    max-width: 100%;
  }

  .page-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .page-toolbar > * {
    width: 100%;
  }

  .profile-grid {
    grid-template-columns: 1fr;
  }

  .invoice-form-topbar {
    flex-direction: column;
    align-items: stretch;
  }

  .invoice-form-topbar__actions {
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .invoice-form-toolbar {
    flex-wrap: wrap;
    width: 100%;
  }

  .invoice-form-toolbar__primary {
    flex-wrap: wrap;
    width: 100%;
  }

  .invoice-btn--approve,
  .invoice-btn--print {
    flex: 1;
    min-width: 0;
  }

  .invoice-scan-bar {
    flex-wrap: wrap;
    width: 100%;
    margin-left: 0 !important;
    margin-top: 8px;
  }

  .enterprise-line-items,
  .invoice-lines-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-row {
    margin-inline: 0 !important;
  }
}

@media (max-width: 576px) {
  .app-topbar {
    padding: 0 10px !important;
  }

  .app-topbar-left,
  .app-topbar-right {
    gap: 6px;
  }

  .app-brand-mark {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }

  .app-content-v2 {
    padding: 10px;
  }

  .invoice-compact-row > .ant-col {
    flex-basis: 100% !important;
  }

  .page-header-title {
    font-size: 18px !important;
  }

  .login-container {
    padding: 16px;
    align-items: center;
  }

  .login-box {
    padding: 22px 18px 18px;
  }

  .ant-picker,
  .ant-select,
  .ant-input-number {
    max-width: 100%;
  }
}

/* Mobile navigation drawer */
.app-nav-drawer .ant-drawer-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
}

.app-nav-drawer .ant-drawer-body {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.app-sider-brand--drawer {
  padding: 0;
}

.app-topbar-menu-btn {
  display: inline-flex !important;
}

/* Zoom / dense-layout safety: never clip interactive controls */
.ant-card,
.ant-form,
.ant-tabs,
.ant-space {
  max-width: 100%;
}

.ant-table-wrapper {
  max-width: 100%;
  overflow-x: auto;
}

@media (max-width: 992px) {
  .app-sider-v2 {
    display: none !important;
  }
}

.page-container {
  max-width: 100%;
  width: 100%;
}

.app-content-v2--workspace {
  padding: 12px 16px;
  overflow: hidden;
}

.purchase-form-page--fit {
  height: 100%;
}

.app-content-v2--dashboard-fit {
  padding: 0;
  overflow-x: auto;
  overflow-y: auto;
  background: #f1f5f9;
}

.app-content-v2--invoice-fit,
.app-content-v2--enterprise-fit {
  padding: 8px 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.app-content-v2--enterprise-fit > * {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.customers-workspace {
  height: 100%;
}

.invoice-form-page--fit {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  padding: 0;
}

.invoice-form-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
  margin-bottom: 10px;
}

.invoice-form-topbar__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  padding: 8px 12px;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
}

.invoice-form-template-select {
  min-width: 160px;
}

.invoice-form-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.invoice-form-toolbar__primary {
  display: flex;
  flex-wrap: nowrap;
}

.invoice-form-toolbar__primary .ant-space-item {
  display: flex;
}

/* Shared invoice / receipt form action buttons */
.invoice-btn {
  height: 36px;
  padding-inline: 16px;
  font-weight: 500;
  font-size: 13px;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
  white-space: nowrap;
}

.invoice-btn--approve {
  min-width: 148px;
}

.invoice-btn--print {
  min-width: 148px;
  background: var(--success) !important;
  border-color: var(--success) !important;
  color: #fff !important;
}

.invoice-btn--print:hover,
.invoice-btn--print:focus {
  background: #16a34a !important;
  border-color: #16a34a !important;
  color: #fff !important;
}

.invoice-btn--more {
  width: 36px;
  padding-inline: 0;
  color: var(--text-body);
  border-color: var(--border-color);
  background: var(--bg-card);
}

.invoice-btn--more:hover {
  color: var(--primary);
  border-color: var(--primary);
  background: var(--primary-subtle);
}

.invoice-btn--cancel {
  min-width: 88px;
  color: var(--text-body);
  border-color: var(--border-color);
  background: var(--bg-card);
}

.invoice-btn--cancel:hover {
  color: var(--text-heading);
  border-color: var(--text-muted);
}

.invoice-btn--scan {
  min-width: 88px;
}

.invoice-btn--add-line {
  min-width: 100px;
  border-color: var(--border-color);
}

.invoice-scan-input {
  width: min(320px, 42vw);
}

.invoice-form-btn-group {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: nowrap;
}

.invoice-form-btn-group .ant-btn {
  margin: 0 !important;
}

.invoice-form-cancel-btn {
  margin-left: 0;
}

.receipt-form-page--fit {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.receipt-form-card--fit {
  flex: 1;
  overflow-y: auto;
}

.receipt-form-summary {
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-light);
}

.receipt-form-summary > div {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  min-width: 120px;
}

.table-actions .ant-btn-link {
  padding: 0 4px;
}

.receipt-detail-page .invoice-form-card {
  padding: 16px 20px;
}

.invoice-form-crumb {
  font-size: 11px;
  display: block;
  line-height: 1.2;
}

.invoice-form-title {
  margin: 0 !important;
  font-size: 18px !important;
  line-height: 1.2 !important;
}

.invoice-form-card--fit {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 12px !important;
  margin: 0;
  overflow: hidden;
}

.invoice-form-card--fit.ant-form {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.invoice-section-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--primary);
  margin-bottom: 4px;
  flex-shrink: 0;
}

.invoice-section-label--scan {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
}

.invoice-scan-bar {
  margin-left: auto;
}

.invoice-compact-row {
  flex-shrink: 0;
}

.invoice-compact-field {
  margin-bottom: 6px !important;
}

.invoice-compact-field .ant-form-item-label {
  padding-bottom: 2px !important;
}

.invoice-compact-field .ant-form-item-label > label {
  font-size: 11px !important;
  height: auto !important;
}

.invoice-lines-table--fit {
  flex: 1;
  min-height: 0;
}

.invoice-lines-scroll {
  flex: 1 1 0;
  min-height: 160px;
  max-height: 100%;
  overflow: hidden;
  position: relative;
}

.invoice-lines-scroll .invoice-lines-table--fit {
  height: 100%;
}

.invoice-lines-scroll .invoice-lines-table--fit .ant-spin-nested-loading,
.invoice-lines-scroll .invoice-lines-table--fit .ant-spin-container {
  height: 100%;
}

.invoice-lines-scroll .invoice-lines-table--fit .ant-table {
  height: 100%;
}

.invoice-lines-scroll .invoice-lines-table--fit .ant-table-container {
  height: 100%;
}

/* Scrollbar styling for line items */
.invoice-lines-scroll .ant-table-body {
  scrollbar-width: thin;
  scrollbar-color: var(--border-color) transparent;
}

.invoice-lines-scroll .ant-table-body::-webkit-scrollbar {
  width: 8px;
}

.invoice-lines-scroll .ant-table-body::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 4px;
}

.invoice-lines-scroll .ant-table-body::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}

.invoice-form-bottom {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-light);
}

.invoice-form-bottom__left {
  flex: 1;
  min-width: 0;
}

.invoice-notes-field {
  margin-bottom: 0 !important;
}

.invoice-summary-box--compact {
  width: 220px;
  flex-shrink: 0;
  margin-top: 18px;
  padding: 10px 14px;
}

.invoice-summary-box--compact .invoice-summary-row {
  padding: 4px 0;
  font-size: 12px;
}

.invoice-summary-box--compact .invoice-summary-row--total {
  font-size: 14px;
  margin-top: 4px;
  padding-top: 6px;
}

.invoice-form-page {
  padding-bottom: 0;
}

.invoice-form-card {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  padding: 20px 24px;
  box-shadow: var(--shadow-sm);
}

.invoice-form-sections .ant-collapse-item {
  border-bottom: 1px solid var(--border-light) !important;
  margin-bottom: 8px;
}

.invoice-form-sections .ant-collapse-header {
  font-weight: 600;
  color: var(--primary);
}

.invoice-lines-table .ant-table-cell {
  vertical-align: middle;
}

.invoice-summary-box {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 16px 20px;
  margin-top: 30px;
}

.invoice-summary-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-body);
}

.invoice-summary-row--total {
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
  padding-top: 12px;
  font-size: 16px;
  font-weight: 700;
  color: var(--text-heading);
}

.invoice-form-footer-section {
  margin-top: 20px;
}

.invoice-form-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--border-light);
}

@media (max-width: 768px) {
  .invoice-form-topbar {
    flex-direction: column;
    align-items: stretch;
  }

  .invoice-form-topbar__actions {
    flex-wrap: wrap;
    justify-content: stretch;
  }

  .invoice-form-toolbar {
    flex-wrap: wrap;
    width: 100%;
  }

  .invoice-form-toolbar__primary {
    flex-wrap: wrap;
    width: 100%;
  }

  .invoice-btn--approve,
  .invoice-btn--print {
    flex: 1;
    min-width: 0;
  }

  .invoice-scan-bar {
    flex-wrap: wrap;
    width: 100%;
    margin-left: 0 !important;
    margin-top: 8px;
  }

  .invoice-scan-input {
    width: 100%;
  }
}

@media (max-width: 992px) {
  .pos-layout {
    flex-direction: column;
    height: auto;
    min-height: calc(100vh - var(--header-height) - 80px);
  }

  .pos-cart-panel {
    width: 100%;
    min-height: 420px;
  }
}

.page-header {
  margin-bottom: 20px;
}

.page-header-breadcrumb {
  margin-bottom: 8px;
}

.breadcrumb-link {
  border: none;
  background: none;
  padding: 0;
  color: var(--primary);
  cursor: pointer;
  font-size: 13px;
}

.page-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.page-header-title {
  margin: 0 !important;
  font-size: 22px !important;
  font-weight: 600 !important;
  color: var(--text-heading);
}

.page-header-subtitle {
  margin: 4px 0 0;
  color: var(--text-muted);
  font-size: 13px;
}

.table-total-row td {
  font-weight: 700;
  background: var(--bg-tertiary) !important;
}

.profile-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));
  gap: 16px;
}

.profile-meta {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 8px 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAE1C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;EAEzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;;EAEtB,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;;EAEtB,uBAAuB;EACvB,uBAAuB;;EAEvB,0CAA0C;EAC1C,yEAAyE;EACzE,mFAAmF;EACnF,qFAAqF;;EAErF,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,sBAAsB;EACtB,qBAAqB;;EAErB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uFAAuF;EACvF,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB,gBAAgB,0BAA0B,EAAE;AAC5C,aAAa,uBAAuB,EAAE;AACtC,cAAc,wBAAwB,EAAE;AACxC,gBAAgB,qBAAqB,EAAE;AACvC,gBAAgB,qBAAqB,EAAE;AACvC,eAAe,mBAAmB,EAAE;AACpC,gBAAgB,qBAAqB,EAAE;;AAEvC,gBAAgB;AAChB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kDAAkD;AACpD;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,kFAAkF;EAClF,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,sBAAsB,iCAAiC,EAAE,qBAAqB,EAAE;AAChF,sBAAsB,iCAAiC,EAAE,qBAAqB,EAAE;AAChF,sBAAsB,iCAAiC,EAAE,qBAAqB,EAAE;AAChF,mBAAmB,8BAA8B,EAAE,kBAAkB,EAAE;;AAEvE,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,0CAA0C;EAC1C,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,4CAA4C;EAC5C,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;EACvD,0BAA0B;EAC1B,uCAAuC;EACvC,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,iDAAiD;EACjD,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,cAAc;EACd,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,oHAAoH;EACpH,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,2BAA2B;EAC3B,uDAAuD;EACvD,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uDAAuD;EACvD,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;;;;EAIE,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qHAAqH;EACrH,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,iCAAiC;EACjC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,uEAAuE;EACvE,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,gFAAgF;EAChF,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qDAAqD;EACrD,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;;IAEE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;IACtB,+BAA+B;IAC/B,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;;EAEA;;;;;;;;;IASE,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;;EAEA;;;;IAIE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;EACzB;;EAEA;IACE,wCAAwC;IACxC,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;IAC9B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gEAAgE;AAChE;;;;EAIE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,OAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,qDAAqD;EACvD;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sEAAsE;EACtE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;AACf","sourcesContent":["/* UniversalPOS — Enterprise Light Theme */\n\n:root {\n  --primary: #2563EB;\n  --primary-hover: #1D4ED8;\n  --primary-light: #3B82F6;\n  --primary-subtle: #E8F2FF;\n\n  --bg-primary: #F5F7FB;\n  --bg-secondary: #FFFFFF;\n  --bg-tertiary: #F9FAFB;\n  --bg-card: #FFFFFF;\n  --bg-hover: #F3F8FF;\n  --bg-selected: #E8F2FF;\n\n  --text-heading: #111827;\n  --text-primary: #111827;\n  --text-body: #374151;\n  --text-secondary: #374151;\n  --text-muted: #6B7280;\n\n  --success: #22C55E;\n  --success-subtle: #DCFCE7;\n  --warning: #F59E0B;\n  --warning-subtle: #FEF3C7;\n  --error: #EF4444;\n  --error-subtle: #FEE2E2;\n  --info: #0EA5E9;\n  --info-subtle: #E0F2FE;\n\n  --border-color: #E5E7EB;\n  --border-light: #F3F4F6;\n\n  --shadow-xs: 0 1px 2px rgba(0, 0, 0, 0.04);\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.04);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.06), 0 4px 6px -4px rgba(0, 0, 0, 0.04);\n\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n\n  --sidebar-width: 260px;\n  --header-height: 64px;\n\n  --transition-fast: 150ms ease;\n  --transition-normal: 200ms ease;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  background: var(--bg-primary);\n  color: var(--text-body);\n  font-size: 14px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  height: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #D1D5DB;\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #9CA3AF;\n}\n\n::selection {\n  background: var(--primary-subtle);\n  color: var(--primary);\n}\n\na {\n  color: var(--primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n}\n\na:hover {\n  color: var(--primary-hover);\n}\n\n/* Typography utilities */\n.text-heading { color: var(--text-heading); }\n.text-body { color: var(--text-body); }\n.text-muted { color: var(--text-muted); }\n.text-primary { color: var(--primary); }\n.text-success { color: var(--success); }\n.text-danger { color: var(--error); }\n.text-warning { color: var(--warning); }\n\n/* Page layout */\n.page-container {\n  max-width: 100%;\n}\n\n.page-header {\n  margin-bottom: 24px;\n}\n\n.page-header h1,\n.page-header .ant-typography h3 {\n  margin: 0 0 4px;\n  color: var(--text-heading);\n  font-weight: 600;\n}\n\n.page-header .page-subtitle {\n  color: var(--text-muted);\n  font-size: 14px;\n}\n\n.page-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.page-card .ant-card-head {\n  border-bottom: 1px solid var(--border-light);\n  min-height: 52px;\n}\n\n.page-card .ant-card-head-title {\n  color: var(--text-heading);\n  font-weight: 600;\n}\n\n/* Animations */\n.fade-in {\n  animation: fadeIn var(--transition-normal) ease-in;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* KPI / Stat cards */\n.stat-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px 24px;\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow var(--transition-fast), border-color var(--transition-fast);\n  height: 100%;\n}\n\n.stat-card:hover {\n  box-shadow: var(--shadow-md);\n  border-color: #D1D5DB;\n}\n\n.stat-card .stat-label {\n  font-size: 13px;\n  color: var(--text-muted);\n  font-weight: 500;\n  margin-bottom: 4px;\n}\n\n.stat-card .stat-value {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--text-heading);\n  line-height: 1.2;\n}\n\n.stat-card .stat-trend {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.stat-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.stat-icon--success { background: var(--success-subtle); color: var(--success); }\n.stat-icon--primary { background: var(--primary-subtle); color: var(--primary); }\n.stat-icon--warning { background: var(--warning-subtle); color: var(--warning); }\n.stat-icon--info { background: var(--info-subtle); color: var(--info); }\n\n/* Custom card */\n.custom-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  box-shadow: var(--shadow-sm);\n  transition: box-shadow var(--transition-fast);\n}\n\n.custom-card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n/* App shell */\n.app-sider {\n  background: var(--bg-secondary) !important;\n  border-right: 1px solid var(--border-color) !important;\n  box-shadow: none !important;\n}\n\n.app-sider .ant-layout-sider-children {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.app-sider .ant-menu {\n  flex: 1;\n  overflow-y: auto;\n  border-inline-end: none !important;\n  padding: 8px;\n}\n\n.app-sider .sider-logo {\n  height: var(--header-height);\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n  border-bottom: 1px solid var(--border-light);\n  gap: 12px;\n}\n\n.app-sider .sider-logo-icon {\n  width: 36px;\n  height: 36px;\n  background: var(--primary);\n  border-radius: var(--radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 16px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.app-sider .sider-logo-text {\n  overflow: hidden;\n}\n\n.app-sider .sider-logo-text .brand-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-heading);\n  display: block;\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.app-sider .sider-logo-text .brand-sub {\n  font-size: 11px;\n  color: var(--text-muted);\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-sider .ant-menu-item {\n  margin: 2px 0;\n  border-radius: var(--radius-md) !important;\n  font-weight: 500;\n}\n\n.app-sider .ant-menu-item .ant-menu-item-icon {\n  font-size: 18px;\n}\n\n.app-sider-footer {\n  margin-top: auto;\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-tertiary);\n}\n\n.app-sider-footer .user-name {\n  color: var(--text-heading);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.app-sider-footer .user-role {\n  color: var(--text-muted);\n  font-size: 11px;\n  text-transform: capitalize;\n}\n\n.app-header {\n  background: var(--bg-secondary) !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  padding: 0 24px !important;\n  height: var(--header-height) !important;\n  line-height: var(--header-height) !important;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: none !important;\n}\n\n.app-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.app-header-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-heading);\n}\n\n.app-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.app-header-search {\n  width: 280px;\n}\n\n.app-header-search .ant-input-affix-wrapper {\n  border-radius: var(--radius-md);\n  background: var(--bg-tertiary);\n  border-color: var(--border-color);\n}\n\n.app-header-icon-btn {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: background var(--transition-fast), color var(--transition-fast);\n}\n\n.app-header-icon-btn:hover {\n  background: var(--bg-hover);\n  color: var(--primary);\n}\n\n.app-content {\n  padding: 24px;\n  background: var(--bg-primary);\n  min-height: calc(100vh - var(--header-height));\n  overflow: auto;\n}\n\n.app-user-trigger {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 4px 8px 4px 4px;\n  border-radius: var(--radius-md);\n  transition: background var(--transition-fast);\n}\n\n.app-user-trigger:hover {\n  background: var(--bg-hover);\n}\n\n.app-user-trigger .user-display-name {\n  color: var(--text-body);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Sales workspace (product grid + cart) */\n.pos-layout {\n  display: flex;\n  height: calc(100vh - var(--header-height) - 48px);\n  gap: 20px;\n  overflow: hidden;\n}\n\n.pos-products-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.pos-search-bar {\n  margin-bottom: 16px;\n  display: flex;\n  gap: 12px;\n}\n\n.pos-products-grid-wrap {\n  flex: 1;\n  overflow: auto;\n  background: var(--bg-card);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.pos-cart-panel {\n  width: 420px;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n}\n\n.product-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  cursor: pointer;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), transform var(--transition-fast);\n  text-align: center;\n}\n\n.product-card:hover {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n\n.product-card .product-name {\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--text-heading);\n  font-size: 13px;\n}\n\n.product-card .product-price {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.cart-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-sm);\n}\n\n.cart-header {\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.cart-items {\n  flex: 1;\n  overflow-y: auto;\n  padding: 8px 12px;\n}\n\n.cart-table .ant-table {\n  width: 100%;\n}\n\n.cart-table .ant-table-tbody > tr > td {\n  padding: 10px 6px;\n  vertical-align: middle;\n}\n\n.cart-table .ant-table-tbody > tr > td:first-child {\n  padding-left: 4px;\n  padding-right: 10px;\n}\n\n.cart-item-name {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  padding: 2px 0;\n}\n\n.cart-item-name-text {\n  display: block;\n  font-size: 13px;\n  line-height: 1.35;\n  white-space: normal;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\n.cart-item-barcode {\n  display: block;\n  font-size: 11px;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cart-item-price,\n.cart-item-total {\n  font-size: 13px;\n  white-space: nowrap;\n}\n\n.cart-item-qty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.cart-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border-light);\n  background: var(--bg-tertiary);\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n.cart-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.cart-total-amount {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--success);\n}\n\n.pos-checkout-btn {\n  height: 52px !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n}\n\n/* Login */\n.login-container {\n  height: 100%;\n  min-height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  background: var(--bg-primary);\n  padding: 24px;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.login-box {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-xl);\n  padding: 28px 32px 24px;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: var(--shadow-lg);\n  margin: auto;\n}\n\n.login-create-account-btn {\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n}\n\n.login-create-account-btn:hover {\n  border-color: var(--primary) !important;\n  color: var(--primary) !important;\n  background: color-mix(in srgb, var(--primary) 8%, transparent) !important;\n}\n\n.login-create-account-row {\n  text-align: center;\n  margin-top: 8px;\n}\n\n.login-box--register {\n  max-width: 480px;\n  max-height: 92vh;\n  overflow-y: auto;\n  padding: 24px 32px;\n}\n\n.login-logo {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.login-logo-icon {\n  width: 56px;\n  height: 56px;\n  background: var(--primary);\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n  color: white;\n}\n\n.login-logo h2 {\n  margin: 0;\n  color: var(--text-heading);\n  font-weight: 700;\n}\n\n.login-logo .login-subtitle {\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n.login-footer {\n  text-align: center;\n  margin-top: 24px;\n  color: var(--text-muted);\n  font-size: 12px;\n}\n\n/* Empty states */\n.empty-state {\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.empty-state-icon {\n  color: var(--text-muted);\n  margin-bottom: 12px;\n}\n\n/* Table wrapper */\n.table-card {\n  border-radius: var(--radius-lg);\n  overflow: auto;\n  max-width: 100%;\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-card .ant-table-wrapper {\n  border-radius: var(--radius-lg);\n  min-width: 0;\n}\n\n/* Toolbar */\n.page-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n/* App loader */\n.app-loader {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw;\n  background: var(--bg-primary);\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n}\n\n.app-loader .spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--border-color);\n  border-top-color: var(--primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.app-loader .text {\n  margin-top: 16px;\n  color: var(--text-muted);\n  font-size: 14px;\n  font-weight: 500;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Ant Design overrides */\n.ant-table {\n  background: var(--bg-card) !important;\n}\n\n.ant-table-thead > tr > th {\n  background: var(--bg-tertiary) !important;\n  color: var(--text-body) !important;\n  font-weight: 600 !important;\n  border-bottom: 1px solid var(--border-color) !important;\n  font-size: 13px !important;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.ant-table-thead > tr > th::before {\n  display: none !important;\n}\n\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid var(--border-light) !important;\n  color: var(--text-body);\n}\n\n.ant-table-tbody > tr:hover > td {\n  background: var(--bg-hover) !important;\n}\n\n.ant-table-wrapper .ant-table-pagination {\n  margin: 16px !important;\n}\n\n.ant-card {\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-sm);\n}\n\n.ant-modal-content {\n  border: 1px solid var(--border-color);\n  box-shadow: var(--shadow-lg) !important;\n}\n\n.ant-form-item-label > label {\n  color: var(--text-body) !important;\n  font-weight: 500;\n}\n\n.ant-input:focus,\n.ant-input-affix-wrapper-focused,\n.ant-select-focused .ant-select-selector,\n.ant-picker-focused {\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12) !important;\n}\n\n.ant-btn-primary {\n  box-shadow: none !important;\n}\n\n.ant-btn-primary:hover {\n  background: var(--primary-hover) !important;\n}\n\n.ant-tabs-tab {\n  font-weight: 500;\n}\n\n.ant-badge-count {\n  box-shadow: none;\n}\n\n.ant-spin-dot-item {\n  background-color: var(--primary) !important;\n}\n\n.ant-message {\n  z-index: 10000 !important;\n}\n\n/* Dashboard */\n.dashboard-page .dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.dashboard-quick-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.dashboard-quick-action {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  text-align: left;\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast), background var(--transition-fast);\n  box-shadow: var(--shadow-sm);\n}\n\n.dashboard-quick-action:hover {\n  border-color: var(--primary);\n  background: var(--bg-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.dashboard-quick-action__icon {\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-md);\n  background: var(--primary-subtle);\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.dashboard-quick-action__text {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.dashboard-quick-action__label {\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--text-heading);\n}\n\n.dashboard-quick-action__desc {\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.dashboard-inventory-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.dashboard-inventory-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.dashboard-inventory-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-heading);\n  line-height: 1.2;\n}\n\n.dashboard-counts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 16px 20px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.dashboard-counts strong {\n  color: var(--text-heading);\n  font-weight: 600;\n}\n\n@media (max-width: 768px) {\n  .dashboard-quick-actions {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .app-header-search {\n    display: none;\n  }\n\n  .pos-layout {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .pos-cart-panel {\n    width: 100%;\n  }\n\n  .app-content {\n    padding: 16px;\n  }\n}\n\n/* === Phase 1: SaaS shell layout === */\n.app-shell {\n  min-height: 100%;\n  height: 100%;\n  max-width: 100%;\n  flex-direction: column;\n  display: flex;\n  overflow: hidden;\n}\n\n.app-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px !important;\n  padding: 0 20px !important;\n  background: linear-gradient(90deg, #1D4ED8 0%, #2563EB 100%) !important;\n  border-bottom: none;\n  line-height: 1;\n  flex-shrink: 0;\n  z-index: 100;\n}\n\n.app-topbar-left,\n.app-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.app-brand-mark {\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.15);\n  color: #fff;\n  font-weight: 700;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.app-topbar-icon,\n.app-topbar-link {\n  color: #fff !important;\n}\n\n.app-topbar-user {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n\n.app-body {\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  overflow: hidden;\n}\n\n.app-sider-v2 {\n  background: var(--bg-card) !important;\n  border-right: 1px solid var(--border-color);\n  transition: width 0.2s ease, min-width 0.2s ease, max-width 0.2s ease !important;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.app-sider-v2 .ant-layout-sider-children {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.app-sider-brand {\n  padding: 16px 16px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.app-sider-brand-name {\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--text-heading);\n}\n\n.app-sider-brand-co {\n  font-size: 11px;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.app-sider-menu {\n  border-inline-end: none !important;\n}\n\n.app-content-v2 {\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  padding: 20px 24px;\n  overflow-x: auto;\n  overflow-y: auto;\n  background: var(--bg-primary);\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.app-content-v2--workspace {\n  padding: 12px 16px;\n  overflow: hidden;\n}\n\n.table-card--scroll {\n  overflow: auto;\n}\n\n.table-card--scroll .ant-table-wrapper {\n  min-width: 100%;\n}\n\n.settings-form-card {\n  max-width: 100%;\n}\n\n.settings-page {\n  width: 100%;\n  max-width: 100%;\n}\n\n.settings-section-title {\n  margin: 0 0 12px !important;\n}\n\n.settings-form--notifications {\n  width: 100%;\n}\n\n.settings-form__actions--inline {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: none;\n}\n\n.settings-tabs .ant-tabs-content {\n  width: 100%;\n}\n\n.settings-tabs .ant-tabs-tabpane {\n  width: 100%;\n}\n\n.settings-page__header {\n  margin-bottom: 16px;\n}\n\n.settings-tabs .ant-tabs-nav {\n  margin-bottom: 16px;\n}\n\n.settings-tabs .ant-tabs-tab {\n  padding: 8px 4px;\n}\n\n.settings-panel {\n  width: 100%;\n  max-width: 100%;\n  border-radius: var(--radius-lg);\n}\n\n.settings-panel__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--border-light);\n}\n\n.settings-panel__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-md);\n  background: rgba(37, 99, 235, 0.1);\n  color: var(--primary);\n  margin-right: 10px;\n  vertical-align: middle;\n}\n\n.settings-panel__title {\n  margin: 0 0 4px !important;\n  display: inline;\n  vertical-align: middle;\n}\n\n.settings-panel__desc {\n  display: block;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.settings-form .ant-form-item {\n  margin-bottom: 16px;\n}\n\n.settings-form__actions {\n  margin-top: 8px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-light);\n}\n\n.settings-status-box {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 16px 20px;\n  height: 100%;\n}\n\n.settings-status-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  gap: 12px;\n}\n\n.settings-table .ant-table {\n  background: transparent;\n}\n\n@media (max-width: 768px) {\n  .settings-panel__header {\n    flex-direction: column;\n  }\n}\n\n.form-page-shell .form-page-subtitle {\n  display: block;\n  margin: -12px 0 16px;\n}\n\n.enterprise-form-page {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 0;\n}\n\n.enterprise-form-page--narrow .enterprise-form-card {\n  max-width: 800px;\n}\n\n.enterprise-form-subtitle {\n  display: block;\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.enterprise-form-card {\n  flex: 1;\n  width: 100%;\n  max-width: 100%;\n  padding: 20px 24px;\n}\n\n.enterprise-form-card .ant-form-item {\n  margin-bottom: 16px;\n}\n\n.enterprise-section-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--primary);\n  margin: 8px 0 12px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--border-light);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.enterprise-line-items-header {\n  display: grid;\n  grid-template-columns: 80px 1fr 100px 120px 90px 48px;\n  gap: 8px;\n  padding: 6px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  border-bottom: 1px solid var(--border-light);\n  margin-bottom: 8px;\n}\n\n.enterprise-line-item-row {\n  display: grid;\n  grid-template-columns: 80px 1fr 100px 120px 90px 48px;\n  gap: 8px;\n  margin-bottom: 8px;\n  align-items: center;\n}\n\n.enterprise-line-items-header--adjust {\n  grid-template-columns: 1fr 120px 120px 48px;\n}\n\n.enterprise-line-item-row--adjust {\n  grid-template-columns: 1fr 120px 120px 48px;\n}\n\n.enterprise-line-items-header--transfer {\n  grid-template-columns: 1fr 120px 48px;\n}\n\n.enterprise-line-item-row--transfer {\n  grid-template-columns: 1fr 120px 48px;\n}\n\n.enterprise-totals-box {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 12px 16px;\n  margin-top: 16px;\n  margin-left: auto;\n  max-width: 320px;\n}\n\n.enterprise-totals-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.enterprise-totals-row--total {\n  border-top: 1px solid var(--border-color);\n  margin-top: 6px;\n  padding-top: 8px;\n  font-weight: 700;\n  font-size: 15px;\n}\n\n.customers-workspace {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n  gap: 12px;\n}\n\n.customers-workspace__stats {\n  flex-shrink: 0;\n}\n\n.customers-workspace__body {\n  display: flex;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.customers-workspace__list {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.customers-workspace__panel {\n  width: 420px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n}\n\n.customers-workspace__panel--open {\n  width: 480px;\n}\n\n.customers-workspace__panel-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border-light);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.customers-workspace__panel-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n.customers-workspace__panel-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 32px;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.customers-workspace__toolbar {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 12px;\n  flex-shrink: 0;\n}\n\n.customers-workspace__table {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.customers-workspace__table .ant-table-row {\n  cursor: pointer;\n}\n\n.customers-workspace__table .ant-table-row--selected {\n  background: rgba(37, 99, 235, 0.08) !important;\n}\n\n@media (max-width: 1200px) {\n  .customers-workspace__body {\n    flex-direction: column;\n    overflow: auto;\n  }\n\n  .customers-workspace__panel,\n  .customers-workspace__panel--open {\n    width: 100%;\n    max-height: 480px;\n  }\n}\n\n@media (max-width: 768px) {\n  .enterprise-line-items-header,\n  .enterprise-line-item-row {\n    grid-template-columns: 1fr;\n  }\n}\n\n.form-page-actions {\n  flex-wrap: wrap;\n}\n\n.page-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.page-toolbar .ant-space {\n  flex-wrap: wrap;\n}\n\n/* Journal Day Book */\n.journals-page .journal-criteria-card {\n  margin-bottom: 16px;\n}\n\n.journals-page .journal-criteria-card .ant-card-head {\n  min-height: 40px;\n  background: #f8fafc;\n}\n\n.journal-daybook-card .ant-card-body {\n  padding-top: 16px;\n}\n\n.journal-daybook-header {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.journal-empty-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.journal-daybook-table .journal-amount-col {\n  font-variant-numeric: tabular-nums;\n}\n\n.journal-daybook-table .journal-totals-row td {\n  background: #f0fdf4 !important;\n  border-top: 2px solid #16a34a;\n}\n\n.journal-daybook-table .ant-table-thead > tr > th {\n  background: #f1f5f9 !important;\n  font-weight: 600;\n  font-size: 12px;\n  white-space: nowrap;\n}\n\n@media (max-width: 992px) {\n  .app-content-v2 {\n    padding: 16px;\n  }\n\n  .page-header,\n  .page-header-row {\n    flex-direction: column;\n    align-items: stretch !important;\n    gap: 12px;\n  }\n\n  .form-page-actions,\n  .page-header-row > *:last-child {\n    width: 100%;\n  }\n\n  .app-content-v2--invoice-fit,\n  .app-content-v2--enterprise-fit,\n  .app-content-v2--enterprise-fit > *,\n  .invoice-form-page--fit,\n  .invoice-form-card--fit,\n  .invoice-form-card--fit.ant-form,\n  .receipt-form-page--fit,\n  .enterprise-form-page,\n  .purchase-form-page--fit {\n    height: auto !important;\n    max-height: none !important;\n    overflow: visible !important;\n    display: block !important;\n  }\n\n  .app-content-v2--invoice-fit,\n  .app-content-v2--enterprise-fit {\n    overflow-x: auto !important;\n    overflow-y: auto !important;\n    display: block !important;\n  }\n\n  .invoice-form-bottom,\n  .invoice-form-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invoice-summary-box,\n  .invoice-summary-box--compact {\n    width: 100% !important;\n    max-width: 100%;\n    margin-top: 12px;\n  }\n\n  .invoice-form-topbar__actions,\n  .invoice-form-toolbar,\n  .invoice-form-toolbar__primary,\n  .invoice-form-btn-group {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .invoice-compact-row > .ant-col {\n    flex: 1 1 calc(50% - 8px) !important;\n    max-width: 100% !important;\n    min-width: 0 !important;\n  }\n\n  .ant-modal {\n    max-width: calc(100vw - 24px) !important;\n    margin: 12px auto !important;\n  }\n\n  .ant-modal .ant-modal-content {\n    max-height: calc(100vh - 48px);\n    overflow: auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .app-topbar-link {\n    display: none !important;\n  }\n\n  .app-content-v2 {\n    padding: 12px;\n  }\n\n  .ant-table {\n    font-size: 12px;\n  }\n\n  .page-container {\n    max-width: 100%;\n  }\n\n  .page-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .page-toolbar > * {\n    width: 100%;\n  }\n\n  .profile-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .invoice-form-topbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invoice-form-topbar__actions {\n    flex-wrap: wrap;\n    justify-content: stretch;\n  }\n\n  .invoice-form-toolbar {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .invoice-form-toolbar__primary {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .invoice-btn--approve,\n  .invoice-btn--print {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .invoice-scan-bar {\n    flex-wrap: wrap;\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 8px;\n  }\n\n  .enterprise-line-items,\n  .invoice-lines-scroll {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ant-row {\n    margin-inline: 0 !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .app-topbar {\n    padding: 0 10px !important;\n  }\n\n  .app-topbar-left,\n  .app-topbar-right {\n    gap: 6px;\n  }\n\n  .app-brand-mark {\n    width: 32px;\n    height: 32px;\n    font-size: 12px;\n  }\n\n  .app-content-v2 {\n    padding: 10px;\n  }\n\n  .invoice-compact-row > .ant-col {\n    flex-basis: 100% !important;\n  }\n\n  .page-header-title {\n    font-size: 18px !important;\n  }\n\n  .login-container {\n    padding: 16px;\n    align-items: center;\n  }\n\n  .login-box {\n    padding: 22px 18px 18px;\n  }\n\n  .ant-picker,\n  .ant-select,\n  .ant-input-number {\n    max-width: 100%;\n  }\n}\n\n/* Mobile navigation drawer */\n.app-nav-drawer .ant-drawer-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.app-nav-drawer .ant-drawer-body {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.app-sider-brand--drawer {\n  padding: 0;\n}\n\n.app-topbar-menu-btn {\n  display: inline-flex !important;\n}\n\n/* Zoom / dense-layout safety: never clip interactive controls */\n.ant-card,\n.ant-form,\n.ant-tabs,\n.ant-space {\n  max-width: 100%;\n}\n\n.ant-table-wrapper {\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n@media (max-width: 992px) {\n  .app-sider-v2 {\n    display: none !important;\n  }\n}\n\n.page-container {\n  max-width: 100%;\n  width: 100%;\n}\n\n.app-content-v2--workspace {\n  padding: 12px 16px;\n  overflow: hidden;\n}\n\n.purchase-form-page--fit {\n  height: 100%;\n}\n\n.app-content-v2--dashboard-fit {\n  padding: 0;\n  overflow-x: auto;\n  overflow-y: auto;\n  background: #f1f5f9;\n}\n\n.app-content-v2--invoice-fit,\n.app-content-v2--enterprise-fit {\n  padding: 8px 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.app-content-v2--enterprise-fit > * {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.customers-workspace {\n  height: 100%;\n}\n\n.invoice-form-page--fit {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n}\n\n.invoice-form-topbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-shrink: 0;\n  margin-bottom: 10px;\n}\n\n.invoice-form-topbar__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  padding: 8px 12px;\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n}\n\n.invoice-form-template-select {\n  min-width: 160px;\n}\n\n.invoice-form-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.invoice-form-toolbar__primary {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.invoice-form-toolbar__primary .ant-space-item {\n  display: flex;\n}\n\n/* Shared invoice / receipt form action buttons */\n.invoice-btn {\n  height: 36px;\n  padding-inline: 16px;\n  font-weight: 500;\n  font-size: 13px;\n  border-radius: 6px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);\n  white-space: nowrap;\n}\n\n.invoice-btn--approve {\n  min-width: 148px;\n}\n\n.invoice-btn--print {\n  min-width: 148px;\n  background: var(--success) !important;\n  border-color: var(--success) !important;\n  color: #fff !important;\n}\n\n.invoice-btn--print:hover,\n.invoice-btn--print:focus {\n  background: #16a34a !important;\n  border-color: #16a34a !important;\n  color: #fff !important;\n}\n\n.invoice-btn--more {\n  width: 36px;\n  padding-inline: 0;\n  color: var(--text-body);\n  border-color: var(--border-color);\n  background: var(--bg-card);\n}\n\n.invoice-btn--more:hover {\n  color: var(--primary);\n  border-color: var(--primary);\n  background: var(--primary-subtle);\n}\n\n.invoice-btn--cancel {\n  min-width: 88px;\n  color: var(--text-body);\n  border-color: var(--border-color);\n  background: var(--bg-card);\n}\n\n.invoice-btn--cancel:hover {\n  color: var(--text-heading);\n  border-color: var(--text-muted);\n}\n\n.invoice-btn--scan {\n  min-width: 88px;\n}\n\n.invoice-btn--add-line {\n  min-width: 100px;\n  border-color: var(--border-color);\n}\n\n.invoice-scan-input {\n  width: min(320px, 42vw);\n}\n\n.invoice-form-btn-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: nowrap;\n}\n\n.invoice-form-btn-group .ant-btn {\n  margin: 0 !important;\n}\n\n.invoice-form-cancel-btn {\n  margin-left: 0;\n}\n\n.receipt-form-page--fit {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.receipt-form-card--fit {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.receipt-form-summary {\n  display: flex;\n  gap: 24px;\n  justify-content: flex-end;\n  margin-top: 16px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border-light);\n}\n\n.receipt-form-summary > div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  min-width: 120px;\n}\n\n.table-actions .ant-btn-link {\n  padding: 0 4px;\n}\n\n.receipt-detail-page .invoice-form-card {\n  padding: 16px 20px;\n}\n\n.invoice-form-crumb {\n  font-size: 11px;\n  display: block;\n  line-height: 1.2;\n}\n\n.invoice-form-title {\n  margin: 0 !important;\n  font-size: 18px !important;\n  line-height: 1.2 !important;\n}\n\n.invoice-form-card--fit {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 12px !important;\n  margin: 0;\n  overflow: hidden;\n}\n\n.invoice-form-card--fit.ant-form {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.invoice-section-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--primary);\n  margin-bottom: 4px;\n  flex-shrink: 0;\n}\n\n.invoice-section-label--scan {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.invoice-scan-bar {\n  margin-left: auto;\n}\n\n.invoice-compact-row {\n  flex-shrink: 0;\n}\n\n.invoice-compact-field {\n  margin-bottom: 6px !important;\n}\n\n.invoice-compact-field .ant-form-item-label {\n  padding-bottom: 2px !important;\n}\n\n.invoice-compact-field .ant-form-item-label > label {\n  font-size: 11px !important;\n  height: auto !important;\n}\n\n.invoice-lines-table--fit {\n  flex: 1;\n  min-height: 0;\n}\n\n.invoice-lines-scroll {\n  flex: 1 1 0;\n  min-height: 160px;\n  max-height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.invoice-lines-scroll .invoice-lines-table--fit {\n  height: 100%;\n}\n\n.invoice-lines-scroll .invoice-lines-table--fit .ant-spin-nested-loading,\n.invoice-lines-scroll .invoice-lines-table--fit .ant-spin-container {\n  height: 100%;\n}\n\n.invoice-lines-scroll .invoice-lines-table--fit .ant-table {\n  height: 100%;\n}\n\n.invoice-lines-scroll .invoice-lines-table--fit .ant-table-container {\n  height: 100%;\n}\n\n/* Scrollbar styling for line items */\n.invoice-lines-scroll .ant-table-body {\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-color) transparent;\n}\n\n.invoice-lines-scroll .ant-table-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.invoice-lines-scroll .ant-table-body::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 4px;\n}\n\n.invoice-lines-scroll .ant-table-body::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}\n\n.invoice-form-bottom {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid var(--border-light);\n}\n\n.invoice-form-bottom__left {\n  flex: 1;\n  min-width: 0;\n}\n\n.invoice-notes-field {\n  margin-bottom: 0 !important;\n}\n\n.invoice-summary-box--compact {\n  width: 220px;\n  flex-shrink: 0;\n  margin-top: 18px;\n  padding: 10px 14px;\n}\n\n.invoice-summary-box--compact .invoice-summary-row {\n  padding: 4px 0;\n  font-size: 12px;\n}\n\n.invoice-summary-box--compact .invoice-summary-row--total {\n  font-size: 14px;\n  margin-top: 4px;\n  padding-top: 6px;\n}\n\n.invoice-form-page {\n  padding-bottom: 0;\n}\n\n.invoice-form-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  padding: 20px 24px;\n  box-shadow: var(--shadow-sm);\n}\n\n.invoice-form-sections .ant-collapse-item {\n  border-bottom: 1px solid var(--border-light) !important;\n  margin-bottom: 8px;\n}\n\n.invoice-form-sections .ant-collapse-header {\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.invoice-lines-table .ant-table-cell {\n  vertical-align: middle;\n}\n\n.invoice-summary-box {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 16px 20px;\n  margin-top: 30px;\n}\n\n.invoice-summary-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 14px;\n  color: var(--text-body);\n}\n\n.invoice-summary-row--total {\n  border-top: 1px solid var(--border-color);\n  margin-top: 8px;\n  padding-top: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-heading);\n}\n\n.invoice-form-footer-section {\n  margin-top: 20px;\n}\n\n.invoice-form-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-light);\n}\n\n@media (max-width: 768px) {\n  .invoice-form-topbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .invoice-form-topbar__actions {\n    flex-wrap: wrap;\n    justify-content: stretch;\n  }\n\n  .invoice-form-toolbar {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .invoice-form-toolbar__primary {\n    flex-wrap: wrap;\n    width: 100%;\n  }\n\n  .invoice-btn--approve,\n  .invoice-btn--print {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .invoice-scan-bar {\n    flex-wrap: wrap;\n    width: 100%;\n    margin-left: 0 !important;\n    margin-top: 8px;\n  }\n\n  .invoice-scan-input {\n    width: 100%;\n  }\n}\n\n@media (max-width: 992px) {\n  .pos-layout {\n    flex-direction: column;\n    height: auto;\n    min-height: calc(100vh - var(--header-height) - 80px);\n  }\n\n  .pos-cart-panel {\n    width: 100%;\n    min-height: 420px;\n  }\n}\n\n.page-header {\n  margin-bottom: 20px;\n}\n\n.page-header-breadcrumb {\n  margin-bottom: 8px;\n}\n\n.breadcrumb-link {\n  border: none;\n  background: none;\n  padding: 0;\n  color: var(--primary);\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.page-header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.page-header-title {\n  margin: 0 !important;\n  font-size: 22px !important;\n  font-weight: 600 !important;\n  color: var(--text-heading);\n}\n\n.page-header-subtitle {\n  margin: 4px 0 0;\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.table-total-row td {\n  font-weight: 700;\n  background: var(--bg-tertiary) !important;\n}\n\n.profile-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(min(100%, 280px), 1fr));\n  gap: 16px;\n}\n\n.profile-meta {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 8px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
